import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  select_task(e) {
    //Turbo.visit(this.task_url)
  }

  get task() {
    return this.targets.find("url").href;
  }
}
